import React from 'react';
const proximaNovaBold = `${process.env.ASSETS_PREFIX}/fonts/proxima_nova_bold.otf`;
const proximaNovaRegular = `${process.env.ASSETS_PREFIX}/fonts/proxima_nova_regular.otf`;
const proximaNovaSemiBold = `${process.env.ASSETS_PREFIX}/fonts/ProximaNova-Semibold.otf`;

const WebSiteFonts = () => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
        @font-face {
          font-family: proxima-nova-bold;
          src: url(${proximaNovaBold}) format("opentype");
          font-weight: bold;
          font-style: normal;
        }
        @font-face {
          font-family: proxima-nova;
          src: url(${proximaNovaBold}) format("opentype");
          font-weight: 700;
          font-style: normal;
        }
        @font-face {
          font-family: proxima-nova;
          src: url(${proximaNovaBold}) format("opentype");
          font-weight: bold;
          font-style: normal;
        }
        @font-face {
          font-family: proxima-nova;
          src: url(${proximaNovaRegular}) format("opentype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: proxima-nova;
          src: url(${proximaNovaRegular}) format("opentype");
          font-weight: 400;
          font-style: normal;
        }

        @font-face {
          font-family: proxima-nova;
          src: url(${proximaNovaRegular}) format("opentype");
          font-weight: 500;
          font-style: normal;
        }

        @font-face {
          font-family: proxima-nova;
          src: url(${proximaNovaSemiBold}) format("opentype");
          font-weight: 600;
          font-style: normal;
        }
      `,
      }}
    ></style>
  );
};

export default WebSiteFonts;
